const SALES_SUMMARY_DEFAULT_COLLAPSED_AGENT_EMAILS = new Set([
  'william.ritossa@luxuryescapes.com',
  'joshua.paling@luxuryescapes.com',
  'sarah.hierstaetter@luxuryescapes.com',
])

export function shouldDefaultSalesSummaryCollapsed(spoofingAgentEmail: string | undefined): boolean {
  return spoofingAgentEmail !== undefined && SALES_SUMMARY_DEFAULT_COLLAPSED_AGENT_EMAILS.has(spoofingAgentEmail.toLowerCase())
}
